import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "PageFooter"
};
const _hoisted_2 = {
  class: "footer_middle"
};
const _hoisted_3 = {
  class: "middle_item"
};
const _hoisted_4 = {
  alt: ""
};
const _hoisted_5 = {
  class: "middle_item"
};
const _hoisted_6 = {
  alt: ""
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _directive_lazy = _resolveDirective("lazy");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_cache[2] || (_cache[2] = _createElementVNode("div", {
    class: "footer_top"
  }, [_createElementVNode("div", {
    class: "top_left"
  }, [_createElementVNode("div", null, "400-6778-983"), _createElementVNode("div", null, "周一至周五 9:00 - 21:00")]), _createElementVNode("a", {
    href: 'tel:4006778983'
  }, "免费咨询")], -1)), _createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_withDirectives(_createElementVNode("img", _hoisted_4, null, 512), [[_directive_lazy, $data.qywxImg]]), _cache[0] || (_cache[0] = _createElementVNode("div", null, "微信客服", -1))]), _createElementVNode("div", _hoisted_5, [_withDirectives(_createElementVNode("img", _hoisted_6, null, 512), [[_directive_lazy, $data.gzhImg]]), _cache[1] || (_cache[1] = _createElementVNode("div", null, "微信公众号", -1))])]), _cache[3] || (_cache[3] = _createElementVNode("div", {
    class: "footer_bottom"
  }, [_createElementVNode("div", null, "©2022 广州禾一科技有限公司 版权所有"), _createElementVNode("div", null, "地址：广州市番禺区巨大创意产业园15栋A102室"), _createElementVNode("a", {
    href: "https://beian.miit.gov.cn",
    target: "_blank"
  }, "粤ICP备19160406号")], -1))]);
}